import { useState } from 'react'
import Ribbon from '../../../../core/common/ribbon/ribbon'
import TextField from '../../../../core/common/textFields/TextField'
import { useGetAllContigencyQuery, useGetProjectLookupsQuery } from '../../../../services/EndPointsApis'
import { svgIcons } from '../../../../style/fonts/SvgIcons'
import SidebarContigencies from './SidebarContigencies'
import { Link } from 'react-router-dom'
import { usePermission } from '../../../../core/hooks/PermissionHook'
import { constantsPermission } from '../../../../Config/Constants'
import DateComp from '../../../../core/common/dateComponent/DateComp'
import NoRecordFound from '../../../../core/common/noRecord/NoRecordFound'
import TableLoading from '../../../../core/common/loadingComponent/TableLoading'

const ContigenciesTab = ({ projectId }: any) => {
    //PermissionHook
    const { view: viewContigencies, edit: editContigencies, create: createContigencies } = usePermission(constantsPermission?.moduleId?.contigencies);

    const [activityToggleContigencies, setActivityToggleContigencies] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [viewOnly, setViewOnly] = useState(false)
    const [contigencyId, setContigencyId] = useState(false)

    //project lookups
    const { data: projectLookups, refetch: projectLookupsRefetch } = useGetProjectLookupsQuery('');
    //Get All Contigencies
    const { data: getAllContigencies, refetch, isFetching } = useGetAllContigencyQuery({ projectId: projectId });


    const handleAddContigencies = () => {
        setActivityToggleContigencies(true);
        setIsEditing(false);
    };

    const handleEditContigencies = (itemId: any) => {
        setContigencyId(itemId)
        setActivityToggleContigencies(true);
        setIsEditing(true)
        setViewOnly(false)
    };

    const closeSidebarContingency = (e: any) => {
        e?.preventDefault();
        setActivityToggleContigencies(false);
        refetch();
    };
    const groupedContingencies = getAllContigencies?.result?.reduce((acc: any, item: any) => {
        const typeId = item?.lst_ContigencyType?.id;
        if (!acc[typeId]) {
            acc[typeId] = [];
        }
        acc[typeId].push(item);
        return acc;
    }, {});

    return (
        <>
            <SidebarContigencies contigencyId={contigencyId} refetch={refetch} projectLookups={projectLookups} setActivityToggleContigencies={setActivityToggleContigencies} activityTogglePopup={activityToggleContigencies} viewOnly={viewOnly} closeSidebar={closeSidebarContingency} isEditing={isEditing} />
            {createContigencies &&
                <Ribbon
                    // items={items}
                    buttonText='+Add a Contingency'
                    buttonClass='add-popup ribbon-btn'
                    onClickbtn={handleAddContigencies}
                />
            }
            {/* <div className='row'>
                <p className='text-redd fs-14 fw-600 mt-2'>This Item is Locked for editing,but you lock Override permissions. If you are sure that you need to make changes to the locked item, then please be espacially carefull while making your changes.</p>

            </div> */}
            <div className='row height-overflow'>
                <div className='col-md-12'>
                    {groupedContingencies && Object.keys(groupedContingencies).length > 0 ? (
                        <div className="mt-3">
                            {Object.keys(groupedContingencies || {}).map(typeId => (
                                <div key={typeId}>
                                    <Link
                                        to="#"
                                        className="task-accordion d-flex gap-2"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#user-${typeId}`}
                                    >
                                        <span className="dropdown-toggle "></span>
                                        <b>
                                            {groupedContingencies[typeId][0].lst_ContigencyType.value}
                                        </b>
                                    </Link>
                                    <>
                                        {groupedContingencies[typeId].map((user: any) => (
                                            <div key={user.id} className="user-accordion mb-3">

                                                <div
                                                    className="tasks-activity tasks w-100 collapse"
                                                    id={`user-${typeId}`}
                                                >
                                                    <span className="cursor-pointer justify-content-end d-flex" onClick={() => handleEditContigencies(user.id)}>
                                                        {svgIcons.updateIcon}
                                                    </span>
                                                    <div className="table-responsive mt-2">
                                                        <table className="table datanew dataTable no-footer table-hover">
                                                            <thead>
                                                                <tr>
                                                                    {/* <th>
                                                                        <input
                                                                            type="checkbox"
                                                                            className='form-check-input cursor-pointer'
                                                                            checked={isTableHeadChecked}
                                                                            onChange={handleTableHeadChange}
                                                                        />
                                                                    </th> */}
                                                                    {/* <th>ID</th> */}
                                                                    <th>ASSIGNED TO </th>
                                                                    <th>RESOLVED BY</th>
                                                                    <th>CONTIGENCY TYPE</th>
                                                                    <th>DATE CREATED</th>
                                                                    <th>DUE DATE</th>
                                                                    <th>DATE RESOLVED</th>
                                                                    <th>ACTIVE</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr
                                                                    className=''>
                                                                    <td>{user?.lst_AssignedTo?.value}</td>
                                                                    <td>{user?.lst_ResolvedBy?.value}</td>
                                                                    <td>{user?.lst_ContigencyType?.value}</td>
                                                                    <td> <DateComp formattedDate={user?.dateCreated} /></td>
                                                                    <td> <DateComp formattedDate={user?.dueDate} /></td>
                                                                    <td> <DateComp formattedDate={user?.dateResolved} /></td>
                                                                    <td>{user?.active === true ?
                                                                        <span className='badge bg-soft-success text-success'>Active</span>
                                                                        :
                                                                        <span className=' badge bg-soft-danger text-danger'>InActive</span>
                                                                    }</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </>

                                </div>
                            ))}
                            <div className='d-flex justify-content-center'>
                                {isFetching &&
                                    <TableLoading />
                                }
                            </div>
                        </div>
                    ) : (
                        <div className="text-center">
                            <NoRecordFound />
                        </div>
                    )
                    }
                </div>
            </div>
        </>
    )
}

export default ContigenciesTab

